import { InjectionKey } from 'vue';
import { createStore, useStore as baseUseStore, Store } from 'vuex';
import { IState } from '@store/interfaces/IState';
import axios from 'axios';
import loader from './plugins/loader';

const debug = process.env.NODE_ENV !== 'production';

// eslint-disable-next-line symbol-description
export const storeKey: InjectionKey<Store<IState>> = Symbol();

export const store = createStore<IState>({
  state: { results: {} },
  mutations: {
    'store/setResultsStore'(state, result) {
      state.results = { ...state.results, [result.name]: result.value };
    },
    'store/setStore'(state, { name, value }) {
      try {
        if (state[name]) {
          state[name].data = { ...state[name].data, ...value };
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
  actions: {
    async 'shareProducts/changeSKU'({ state, commit }, { result, size }) {
      try {
        commit('global/loaderStart');
        // console.log(result, size);
        const url = size.detailPage;
        const { data } = await axios.get(url, { params: { api: 'y' } });

        const newData = {
          ...state?.results?.cabinetShare,
          items: state?.results?.cabinetShare?.items.map((el) => {
            if (el.id === result.id) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              return data?.product;
            }
            return el;
          }),
        };

        commit('store/setResultsStore', { name: 'cabinetShare', value: newData });
        commit('global/loaderStop');
      } catch (err) {
        console.error(err);
      }
    },
  },
  getters: {
    /**
     * get LANGUAGE_ID for request params
     * @param siteLanguages
     * @returns {{LANGUAGE_ID}}
     */
    getRequestLang: ({ results: { siteLanguages } }) => {
      const activeLanguage =
        siteLanguages?.items && Object.values(siteLanguages.items).find((el) => el.current);

      return { LANGUAGE_ID: activeLanguage?.code };
    },
    getCurrentLang: ({ results: { siteLanguages } }) => {
      if (siteLanguages?.items) {
        return Object.values(siteLanguages?.items)?.find((el) => el.current);
      }
      return null;
    },
    isProd: ({ results: { siteLanguages } }) => siteLanguages?.isProd,
    isGlobalVersion: ({ results: { siteSettings } }) => siteSettings?.isGlobalVersion,
    getSelectedCountry: ({ results: { deliveryCountries } }) =>
      deliveryCountries?.items.find((el) => el.isUserCountry),
  },
  modules: {
    cabinet: require('./modules/cabinet/cabinet').default,
    personal: require('./modules/personal').default,
    favourite: require('./modules/favourite').default,
    global: require('./modules/global/global').default,
    product: require('./modules/product').default,
    cities: require('./modules/cities').default,
    basket: require('./modules/basket').default,
    catalog: require('./modules/catalog').default,
    checkout: require('./modules/checkout').default,
    thanks: require('./modules/thanks').default,
    club: require('./modules/club').default,
    repair: require('./modules/repair').default,
    service: require('./modules/service').default,
    footerMiniBanner: require('./modules/footerMiniBanner').default,
    happyBirthdayBanner: require('./modules/happyBirthdayBanner').default,
  },
  plugins: [loader],
  strict: debug,
});

export function useStore() {
  return baseUseStore(storeKey);
}
